import {
  Injectable,
  ComponentRef,
  EmbeddedViewRef
} from '@angular/core';
import { JoyrideStep, JoyrideStepInstance } from '../joyride.domain';

@Injectable({ providedIn: 'root' })
export class JoyrideStepDrawerService {
  private refMap: Record<string, ComponentRef<JoyrideStepInstance>> = {};

  draw(step: JoyrideStep): void {
    // 1. Create a component reference from the component
    const ref: ComponentRef<JoyrideStepInstance> = step.targetViewContainer
      .createComponent(step.stepComponent);

    // 2. Get DOM element from component
    const domElem = (ref.hostView as EmbeddedViewRef<unknown>)
      .rootNodes[0] as HTMLElement;

    // 3. Append DOM element to the body
    document.body.appendChild(domElem);

    const instance: JoyrideStepInstance = ref.instance;
    ref.setInput('step', step);
    ref.changeDetectorRef.detectChanges();
    step.stepInstance = instance;

    this.refMap[step.name] = ref;
  }

  remove(step: JoyrideStep): void {
    this.refMap[step.name].destroy();
  }
}
